// Figma file: https://www.figma.com/design/RLAwR3rK22mTGAOYui5uSQ/Web-Structure?node-id=557-2995&m=dev

import { CSSProperties, ElementType, forwardRef, ReactNode } from "react"

import { cn } from "@/lib/utils"

import { typographyTags, type TypographyVariant, typographyVariants, type TypographyWeight } from "./consts"

interface TypographyProps {
  variant?: TypographyVariant
  weight?: TypographyWeight
  as?: ElementType
  className?: string
  children: ReactNode
  style?: CSSProperties
}

export const Typography = forwardRef<HTMLElement, TypographyProps>(
  ({ variant = "body1", weight, as, className = "", children, style, ...rest }, ref) => {
    const Tag = as || typographyTags[variant]
    const classNames = cn(typographyVariants({ variant, weight }), className)

    return (
      <Tag ref={ref} className={classNames} style={style} {...rest}>
        {children}
      </Tag>
    )
  },
)
